import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { MedicationInfusionAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-medication-infusion-slot',
    templateUrl: './medication-infusion-slot.component.html',
    styleUrl: './medication-infusion-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedicationInfusionSlotComponent implements SheetSlotComponentBase {

	action!: MedicationInfusionAction;
	value!: string | null;

	@Input('action') set updateAction(action: MedicationInfusionAction | null) {
		this.action = action as MedicationInfusionAction;
		this.value = this.action.rate?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}